import { Menu, MenuItem } from '@mui/material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../reduxService/hooks';
import PDF from '../../../PDF/PDF';
import { getActionByProjectType } from '../../../../actionMap';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import '../../../../style/mui.scss';
import { IDownloadButtonProps } from './IExportButton';
import { IInitialState } from '../../../../../reduxService';
import { IProjectMacra1 } from '../../../../MACRA_1/store/project/projectSlice';
import { IProjectMacra2 } from '../../../../MACRA_2/store/project/projectSlice';
import { Pdf } from './pdfjs';
import { IProjectResultResponse } from '../../../../MACRA_1/api/IApiResponse';
import { EProjectType } from '../../../../enum/project';
import PDFMacra2 from '../../../PDF/PDFMacra2/PDFMacra2';
import { ISlopedGabionResults, ISteppedGabionResults, IVerticalDropsResults } from '../../../../MACRA_2/api/IApiResponse';
import { selectStillingBasinAndSoilDataByProject } from '../../../../MACRA_2/selector/conversion';

const DownloadButton = (props: IDownloadButtonProps) => {
    const { t } = useTranslation();

    const { selectProject, selectResults } = getActionByProjectType();

    const project: IInitialState<IProjectMacra1 | IProjectMacra2> = useAppSelector(selectProject as any);
    const projectInfo = useAppSelector(selectProjectInfo);
    const stillingBasinSoilData = useAppSelector(selectStillingBasinAndSoilDataByProject);
    const results: IInitialState<IProjectResultResponse | ISteppedGabionResults | ISlopedGabionResults | IVerticalDropsResults> = useAppSelector(selectResults as any);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [pdfUrl, setPdfUrl] = React.useState<string>('');
    const [imgs, setImgs] = React.useState<string[]>([]);

    const open = Boolean(anchorEl);

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    if (projectInfo.data?.type !== EProjectType.Macra1) {
        (project.data as IProjectMacra2).stillingBasin = stillingBasinSoilData!.stillingBasin!;
        (project.data as IProjectMacra2).soilData = stillingBasinSoilData!.soilData!;
    }
    return (
        <>
            <button type='button' className={props.className} onClick={handleClick}>
                <i className='fa-solid fa-download' />
                {t('header_export_button')}
                <i className='fa-solid fa-angle-down' />
            </button>

            <Menu
                id='basic-menu-export'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                <MenuItem className={props.className} onClick={handleClose}>
                    <PDFDownloadLink
                        className={'MuiMenuItem-root'}
                        document={
                            projectInfo.data?.type === EProjectType.Macra1 ? (
                                <PDF
                                    project={project.data! as IProjectMacra1}
                                    projectInfo={projectInfo.data!}
                                    results={results.data! as IProjectResultResponse}
                                    channelDesignImg={results.data?.channelDesignImg || ''}
                                    dischargeCurveImg={results.data?.dischargeCurveImg || ''}
                                />
                            ) : (
                                <PDFMacra2
                                    project={project.data! as IProjectMacra2}
                                    projectInfo={projectInfo.data!}
                                    results={results.data! as ISteppedGabionResults | ISlopedGabionResults | IVerticalDropsResults}
                                    channelDesignImg={results.data?.channelDesignImg || ''}
                                    dischargeCurveImg={results.data?.dischargeCurveImg || ''}
                                />
                            )
                        }
                        fileName={projectInfo.data?.name}>
                        {/* //TODO hover */}
                        {({ url, loading }) => {
                            React.useEffect(() => {
                                if (url && !pdfUrl) {
                                    setPdfUrl(url);
                                }
                            }, [url]);

                            return loading ? <div>{t('header_export_button_pdf_downloading')}</div> : <div>{t('header_export_button_pdf')}</div>;
                        }}
                    </PDFDownloadLink>
                </MenuItem>

                <Pdf pdfUrl={pdfUrl} className={props.className} onClick={handleClose} setImgs={setImgs} imgs={imgs} />
            </Menu>
        </>
    );
};

export default DownloadButton;
